<div
    *ngIf="buttonsData.length"
    class="flexbox align-items-start display-mobile-flex-column display-sm-flex-column display-md-flex-row display-lg-flex-row display-desktop-flex-row"
    [ngClass]="styleClass"
>
    <ng-container *ngFor="let button of buttonsData; let lastItem = last;">
        <ng-container [ngSwitch]="button.type">
            <button
                *ngSwitchCase="'button'"
                class="btn btn_alt-default margin-mobile-right-0 margin-sm-right-0"
                [ngClass]="lastItem ? 'no-margin' : 'margin-mobile-bottom-sm margin-sm-bottom-sm'"
                (click)="onButtonClick($event, button)"
            >
                {{ button.label }}
            </button>

            <a
                *ngSwitchCase="'anchor'"
                class="btn btn_alt-default margin-mobile-right-0 margin-sm-right-0"
                [ngClass]="lastItem ? 'no-margin' : 'margin-mobile-bottom-sm margin-sm-bottom-sm'"
                [target]="button.target"
                [href]="button.href"
            >
                {{ button.label }}
            </a>
        </ng-container>
    </ng-container>
</div>
